/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
// formik
import { Formik } from 'formik';
import * as Yup from 'yup';
// @material-ui/icons
import Lock from '@material-ui/icons/Lock';
import Email from '@material-ui/icons/Email';
import Phone from '@material-ui/icons/Phone';
import Fullname from '@material-ui/icons/Person';
// @material-ui/core components
import validationFormsStyle from 'assets/jss/material-dashboard-pro-react/views/validationFormsStyle';
import Check from '@material-ui/icons/Check';
import Checkbox from '@material-ui/core/Checkbox';
import FormControl from '@material-ui/core/FormControl';
import withStyles from '@material-ui/core/styles/withStyles';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormControlLabel from '@material-ui/core/FormControlLabel';
// core components
import Card from 'components/UI/Card/Card';
import CardBody from 'components/UI/Card/CardBody';
import Button from 'components/UI/CustomButtons/Button';
import CustomInput from 'components/UI/CustomInput/CustomInput';
import Snackbars from 'components/UI/Snackbar/Snackbar';
import GridContainer from 'components/UI/Grid/GridContainer';
import GridItem from 'components/UI/Grid/GridItem';
// Helper
import RouterContext from 'helpers/routerContext';
// our components
import WithPermission from 'components/User/WithPermission';
import Loading from 'components/common/Loading';
import agencyPaymentMethodTextHelper from 'helpers/agencyPaymentMethodTextHelper';
// global variables
import {
  userRanks,
  userKinds,
  leads,
  agencyPaymentMethod,
  cardProvider,
} from 'config';
// our routes
import { USER } from 'routes/paths';
import SelectAgency from 'components/common/SelectAgency';
import AuthContext from 'helpers/authContext';
import InfoUser from 'components/common/InfoUser';
import TagsInput from 'react-tagsinput';
import Select from '@material-ui/core/Select/Select';
import MenuItem from '@material-ui/core/MenuItem/MenuItem';

/**
 * Validation form's rules
 */
const validationSchema = Yup.object({
  fullname: Yup.string('Este campo debe de tener valor').required(
    'fullname requerido',
  ),
  email: Yup.string('Enter your email')
    .email('Enter a valid email')
    .when('phone', {
      is: value => !value,
      then: Yup.string('Enter your email').required(
        'Without phone the email is required',
      ),
    }),
  phone: Yup.number('Enter your phone'),
  password1: Yup.string('').when('userKind', {
    is: value => value !== userKinds.USER_AGENCY,
    then: Yup.string()
      .min(6, 'Password must contain at least 6 characters')
      .required('Enter your password'),
  }),
  password2: Yup.string('Enter your password').when('userKind', {
    is: value => value !== userKinds.USER_AGENCY,
    then: Yup.string()
      .required('Confirm your password')
      .oneOf([Yup.ref('password1')], 'Password does not match'),
  }),
  rank: Yup.string('Este campo debe de tener valor').required(
    'user type requerido',
  ),
  commissionLead: Yup.number().when('userKind', {
    is: userKinds.AGENCY,
    then: Yup.number().required('This field is required'),
  }),
  commissionLeadRevolico: Yup.number().when('userKind', {
    is: userKinds.AGENCY,
    then: Yup.number().required('This field is required'),
  }),
  leadAgency: Yup.string('').when('fromAgency', {
    is: true,
    then: Yup.string().required('This field is required'),
  }),
});

/**
 * @class
 * @extends React.Component
 */
class UserCreate extends React.Component {
  static contextType = RouterContext;

  constructor(props) {
    super(props);
    const { fromAgency, agencyId } = this.props;
    this.state = {
      fields: {
        fullname: '',
        email: '',
        phone: '',
        password1: '',
        password2: '',
        changePassOnLogin: true,
        rank: userRanks.USER,
        userKind: fromAgency ? userKinds.USER_AGENCY : userKinds.USER,
        isActive: true,
        commissionLead: '',
        commissionLeadRevolico: '',
        leadAgency: agencyId,
        lead: fromAgency ? leads.REVOLICO : '',
        allowedIps: [],
        negativeCredit: false,
        paymentMethod: agencyPaymentMethod.CASH,
        fromAgency,
        cardProvider: 'A_',
      },
    };

    this.formikRef = null;
  }

  /**
   * @description
   * Set server errors with Formik setErrors function.
   *
   * @param {Array} serverErrors - Api errors.
   * @returns {Object} Global form's errors.
   */
  setServerErrors = serverErrors => {
    let all = null;
    if (this.formikRef && serverErrors.length) {
      const errors = {};

      serverErrors.forEach(item => {
        errors[item.field] = item.messages;
        if (item.field === '__all__') {
          all = item.messages;
        }
      });

      setTimeout(() => this.formikRef && this.formikRef.setErrors(errors), 0);
    }
    return all;
  };

  /**
   * @description
   * Handle redirect of cancel btn.
   */
  handleCancelBtn = () => {
    const history = this.context;
    history.push(USER.LIST);
  };

  /**
   * @description
   * Render Create User form using Formik.
   *
   * @returns {*} Create User component.
   */
  render() {
    const { fields } = this.state;
    const {
      classes,
      errors: serverErrors,
      userCreate,
      fromAgency,
      agencyId,
      loading,
      t,
    } = this.props;
    const all = this.setServerErrors(serverErrors);
    return (
      <AuthContext.Consumer>
        {/* eslint-disable-next-line consistent-return */}
        {user => {
          const hasGeneral =
            user.allPermissions.filter(
              permission => permission.codename === 'add_useragency',
            ).length === 1;
          return (
            <GridContainer justify="center">
              <Snackbars
                place="tc"
                message={all || ''}
                open={!!all}
                color="danger"
              />
              <Formik
                ref={ref => {
                  this.formikRef = ref;
                }}
                initialValues={{ ...fields }}
                validationSchema={validationSchema}
                onSubmit={values => {
                  this.setState({
                    fields: { ...values },
                  });
                  userCreate({ ...values });
                }}
                render={({
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleSubmit,
                  handleBlur,
                }) => (
                  <GridItem className={classes.cardContainer}>
                    <h3>{t('user.create.title')}</h3>
                    <form onSubmit={handleSubmit} autoComplete="off">
                      <Card>
                        <Loading show={loading} />
                        <CardBody>
                          <GridContainer direction="column" alignItems="center">
                            <GridItem xs={12} sm={10}>
                              <CustomInput
                                labelText={t('user.create.name')}
                                id="fullname"
                                data-cy="userFullname"
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                helpText={
                                  touched.fullname ? errors.fullname : ''
                                }
                                error={
                                  touched.fullname && Boolean(errors.fullname)
                                }
                                inputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <Fullname
                                        className={classes.inputAdornmentIcon}
                                      />
                                    </InputAdornment>
                                  ),
                                  value: values.fullname,
                                  onChange: e => {
                                    handleChange(e);
                                  },
                                  onBlur: handleBlur,
                                  type: 'text',
                                }}
                              />
                              <CustomInput
                                labelText={t('user.create.email')}
                                id="email"
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                helpText={touched.email ? errors.email : ''}
                                error={touched.email && Boolean(errors.email)}
                                inputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <Email
                                        className={classes.inputAdornmentIcon}
                                      />
                                    </InputAdornment>
                                  ),
                                  value: values.email,
                                  onChange: e => {
                                    handleChange(e);
                                  },
                                  onBlur: handleBlur,
                                  type: 'email',
                                }}
                              />
                              <CustomInput
                                labelText={t('user.create.phone')}
                                id="phone"
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                helpText={touched.phone ? errors.phone : ''}
                                error={touched.phone && Boolean(errors.phone)}
                                inputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <Phone
                                        className={classes.inputAdornmentIcon}
                                      />
                                    </InputAdornment>
                                  ),
                                  value: values.phone,
                                  onChange: e => {
                                    handleChange(e);
                                  },
                                  onBlur: handleBlur,
                                }}
                              />
                              {!fromAgency ? (
                                <div>
                                  <CustomInput
                                    labelText={t('common.pass.title')}
                                    id="password1"
                                    formControlProps={{
                                      fullWidth: true,
                                    }}
                                    helpText={
                                      touched.password1 ? errors.password1 : ''
                                    }
                                    error={
                                      touched.password1 &&
                                      Boolean(errors.password1)
                                    }
                                    inputProps={{
                                      endAdornment: (
                                        <InputAdornment position="end">
                                          <Lock
                                            className={
                                              classes.inputAdornmentIcon
                                            }
                                          />
                                        </InputAdornment>
                                      ),
                                      value: values.password1,
                                      onChange: e => {
                                        handleChange(e);
                                      },
                                      onBlur: handleBlur,
                                      type: 'password',
                                    }}
                                  />
                                  <CustomInput
                                    labelText={t('common.pass.confirm')}
                                    id="password2"
                                    formControlProps={{
                                      fullWidth: true,
                                    }}
                                    helpText={
                                      touched.password2 ? errors.password2 : ''
                                    }
                                    error={
                                      touched.password2 &&
                                      Boolean(errors.password2)
                                    }
                                    inputProps={{
                                      endAdornment: (
                                        <InputAdornment position="end">
                                          <Lock
                                            className={
                                              classes.inputAdornmentIcon
                                            }
                                          />
                                        </InputAdornment>
                                      ),
                                      value: values.password2,
                                      onChange: e => {
                                        handleChange(e);
                                      },
                                      onBlur: handleBlur,
                                      type: 'password',
                                    }}
                                  />

                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        id="changePassOnLogin"
                                        tabIndex={-1}
                                        onClick={handleChange}
                                        checkedIcon={
                                          <Check
                                            data-cy="changePassOnLoginChecked"
                                            className={classes.checkedIcon}
                                          />
                                        }
                                        icon={
                                          <Check
                                            data-cy="changePassOnLoginUnChecked"
                                            className={classes.uncheckedIcon}
                                          />
                                        }
                                        classes={{
                                          checked: classes.checked,
                                        }}
                                        checked={values.changePassOnLogin}
                                      />
                                    }
                                    label={t('user.create.checkbox')}
                                    className={classes.userSelect}
                                  />

                                  <div
                                    className={classes.editUserFormContainer}
                                  >
                                    <h6>{t('user.create.permissions')}</h6>
                                    <div className={classes.buttonGroup}>
                                      <Button
                                        color="info"
                                        round
                                        className={classes.firstButton}
                                        simple={values.rank !== userRanks.ADMIN}
                                        onClick={() =>
                                          handleChange({
                                            target: {
                                              name: 'rank',
                                              value: userRanks.ADMIN,
                                            },
                                          })
                                        }
                                        id="permission-admin"
                                      >
                                        {t(
                                          'user.create.permissions_type.admin',
                                        )}
                                      </Button>
                                      <Button
                                        color="info"
                                        round
                                        className={classes.middleButton}
                                        simple={values.rank !== userRanks.STAFF}
                                        onClick={() =>
                                          handleChange({
                                            target: {
                                              name: 'rank',
                                              value: userRanks.STAFF,
                                            },
                                          })
                                        }
                                        id="permission-staff"
                                      >
                                        {t(
                                          'user.create.permissions_type.staff',
                                        )}
                                      </Button>
                                      <Button
                                        color="info"
                                        round
                                        className={classes.lastButton}
                                        simple={values.rank !== userRanks.USER}
                                        onClick={() =>
                                          handleChange({
                                            target: {
                                              name: 'rank',
                                              value: userRanks.USER,
                                            },
                                          })
                                        }
                                        id="permission-none"
                                      >
                                        {t('user.create.permissions_type.none')}
                                      </Button>
                                    </div>
                                  </div>
                                  <div>
                                    <FormControl
                                      fullWidth
                                      className={classes.userSelect}
                                    >
                                      <h6>{t('user.create.user_type')}</h6>
                                      <GridContainer>
                                        <GridItem xs={6}>
                                          <Button
                                            data-cy="userTypeUser"
                                            color="info"
                                            round
                                            simple={
                                              values.userKind !== userKinds.USER
                                            }
                                            onClick={() =>
                                              handleChange({
                                                target: {
                                                  name: 'userKind',
                                                  value: userKinds.USER,
                                                },
                                              })
                                            }
                                            id="user-type"
                                            fullWidth
                                          >
                                            {t('user.create.user_roles.user')}
                                          </Button>
                                        </GridItem>
                                        <WithPermission
                                          allowPermissions={['add_agency']}
                                        >
                                          <GridItem xs={6}>
                                            <Button
                                              data-cy="userTypeAgency"
                                              color="info"
                                              round
                                              simple={
                                                values.userKind !==
                                                userKinds.AGENCY
                                              }
                                              onClick={() =>
                                                handleChange({
                                                  target: {
                                                    name: 'userKind',
                                                    value: userKinds.AGENCY,
                                                  },
                                                })
                                              }
                                              id="agency-type"
                                              fullWidth
                                            >
                                              {t(
                                                'user.create.user_roles.agency',
                                              )}
                                            </Button>
                                          </GridItem>
                                        </WithPermission>
                                      </GridContainer>
                                    </FormControl>
                                    {values.userKind === userKinds.AGENCY && (
                                      <GridContainer>
                                        <GridItem xs={6}>
                                          <CustomInput
                                            labelText={t(
                                              'user.create.agency.commission.agency',
                                            )}
                                            id="commissionLead"
                                            formControlProps={{
                                              fullWidth: true,
                                            }}
                                            helpText={
                                              touched.commissionLead
                                                ? errors.commissionLead
                                                : ''
                                            }
                                            error={
                                              touched.commissionLead &&
                                              Boolean(errors.commissionLead)
                                            }
                                            inputProps={{
                                              value: values.commissionLead,
                                              onChange: e => {
                                                handleChange(e);
                                              },
                                              onBlur: handleBlur,
                                            }}
                                          />
                                        </GridItem>
                                        <GridItem xs={6}>
                                          <CustomInput
                                            labelText={t(
                                              'user.create.agency.commission.revolico',
                                            )}
                                            id="commissionLeadRevolico"
                                            formControlProps={{
                                              fullWidth: true,
                                            }}
                                            helpText={
                                              touched.commissionLeadRevolico
                                                ? errors.commissionLeadRevolico
                                                : ''
                                            }
                                            error={
                                              touched.commissionLeadRevolico &&
                                              Boolean(
                                                errors.commissionLeadRevolico,
                                              )
                                            }
                                            inputProps={{
                                              value:
                                                values.commissionLeadRevolico,
                                              onChange: e => {
                                                handleChange(e);
                                              },
                                              onBlur: handleBlur,
                                            }}
                                          />
                                        </GridItem>
                                        <FormControl
                                          fullWidth
                                          className={classes.userSelect}
                                        >
                                          <h6>
                                            {t(
                                              'user.create.agency.payment_method.title',
                                            )}
                                          </h6>
                                          <GridContainer>
                                            {Object.keys(
                                              agencyPaymentMethod,
                                            ).map(key => (
                                              <GridItem xs={6}>
                                                <Button
                                                  data-cy="agencyPaymentMethod"
                                                  color="info"
                                                  round
                                                  simple={
                                                    values.paymentMethod !== key
                                                  }
                                                  onClick={() =>
                                                    handleChange({
                                                      target: {
                                                        name: 'paymentMethod',
                                                        value: key,
                                                      },
                                                    })
                                                  }
                                                  id={`agency-payment-method-${key}`}
                                                  fullWidth
                                                >
                                                  {agencyPaymentMethodTextHelper(
                                                    key,
                                                    t,
                                                  )}
                                                </Button>
                                              </GridItem>
                                            ))}
                                          </GridContainer>
                                        </FormControl>
                                      </GridContainer>
                                    )}
                                  </div>
                                </div>
                              ) : (
                                <React.Fragment>
                                  <FormControl
                                    fullWidth
                                    className={classes.userSelect}
                                    style={{ marginBottom: '40px' }}
                                  >
                                    <h6>{t('userAgency.agency')}</h6>
                                    {hasGeneral ||
                                    user.rank === userRanks.ADMIN ? (
                                      <SelectAgency
                                        value={values.leadAgency}
                                        disabled={agencyId !== ''}
                                        handleChange={handleChange}
                                        errorText={errors.leadAgency}
                                      />
                                    ) : (
                                      <InfoUser user={user} />
                                    )}
                                  </FormControl>
                                  <FormControl
                                    fullWidth
                                    className={classes.userSelect}
                                    style={{ marginBottom: '30px' }}
                                  >
                                    <h6> {t('userAgency.lead')} </h6>
                                    <GridContainer>
                                      <GridItem xs={12} sm={6}>
                                        <Button
                                          data-cy="lead"
                                          name="sellerLead"
                                          simple={values.lead !== leads.SELLER}
                                          round
                                          fullWidth
                                          color="info"
                                          onClick={evt => {
                                            const targetEvent = {
                                              ...evt,
                                              target: {
                                                ...evt.target,
                                                id: 'lead',
                                                value: leads.SELLER,
                                              },
                                            };
                                            handleChange(targetEvent);
                                          }}
                                        >
                                          {t('userAgency.agency')}
                                        </Button>
                                      </GridItem>
                                      <GridItem xs={12} sm={6}>
                                        {' '}
                                        <Button
                                          data-cy="revoLead"
                                          name="revoLead"
                                          simple={
                                            values.lead !== leads.REVOLICO
                                          }
                                          round
                                          fullWidth
                                          color="info"
                                          onClick={evt => {
                                            const targetEvent = {
                                              ...evt,
                                              target: {
                                                ...evt.target,
                                                id: 'lead',
                                                value: leads.REVOLICO,
                                              },
                                            };
                                            handleChange(targetEvent);
                                          }}
                                        >
                                          Revolico
                                        </Button>
                                      </GridItem>
                                    </GridContainer>
                                  </FormControl>
                                </React.Fragment>
                              )}

                              <WithPermission
                                allowPermissions={['change_card_provider']}
                              >
                                <FormControl
                                  fullWidth
                                  className={classes.userSelect}
                                  style={{ marginTop: '24px' }}
                                >
                                  <h6>
                                    {t('user.create.card_provider.title')}
                                  </h6>
                                  <Select
                                    id="card_provider"
                                    MenuProps={{
                                      className: classes.selectMenu,
                                    }}
                                    classes={{
                                      select: classes.select,
                                    }}
                                    name="cardProvider"
                                    onChange={handleChange}
                                    value={values.cardProvider}
                                    className={classes.reviewDD}
                                  >
                                    <MenuItem
                                      classes={{
                                        root: classes.selectMenuItem,
                                        selected:
                                          classes.selectMenuItemSelected,
                                      }}
                                      value="A_"
                                    >
                                      {t(
                                        'user.create.card_provider.without_card_provider',
                                      )}
                                    </MenuItem>
                                    {Object.keys(cardProvider).map(key => (
                                      <MenuItem
                                        key={key}
                                        classes={{
                                          root: classes.selectMenuItem,
                                          selected:
                                            classes.selectMenuItemSelected,
                                        }}
                                        value={cardProvider[key]}
                                      >
                                        {key}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                </FormControl>
                              </WithPermission>

                              <WithPermission allowPermissions={[]}>
                                <div className={classes.editUserFormContainer}>
                                  <h6>{t('user.create.allowed_ip')}</h6>
                                  <TagsInput
                                    value={values.allowedIps}
                                    onlyUnique
                                    onChange={ipAddress =>
                                      handleChange({
                                        target: {
                                          name: 'allowedIps',
                                          value: ipAddress,
                                        },
                                      })
                                    }
                                    tagProps={{
                                      className: 'react-tagsinput-tag info',
                                    }}
                                    inputProps={{
                                      placeholder: t(
                                        'user.create.allowed_ip_placeholder',
                                      ),
                                    }}
                                  />
                                </div>
                              </WithPermission>

                              <FormControlLabel
                                control={
                                  <Checkbox
                                    data-cy="isActive"
                                    id="isActive"
                                    tabIndex={-1}
                                    onClick={handleChange}
                                    checkedIcon={
                                      <Check className={classes.checkedIcon} />
                                    }
                                    icon={
                                      <Check
                                        className={classes.uncheckedIcon}
                                      />
                                    }
                                    classes={{
                                      checked: classes.checked,
                                    }}
                                    checked={values.isActive}
                                  />
                                }
                                label={t('user.create.checkbox_active')}
                              />
                              <WithPermission
                                allowPermissions={['change_negative_credit']}
                              >
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      data-cy="negativeCredit"
                                      id="negativeCredit"
                                      tabIndex={-1}
                                      onClick={handleChange}
                                      checkedIcon={
                                        <Check
                                          className={classes.checkedIcon}
                                        />
                                      }
                                      icon={
                                        <Check
                                          className={classes.uncheckedIcon}
                                        />
                                      }
                                      classes={{
                                        checked: classes.checked,
                                      }}
                                      checked={values.negativeCredit}
                                    />
                                  }
                                  label={t(
                                    'user.create.checkbox_negative_credit',
                                  )}
                                />
                              </WithPermission>
                            </GridItem>
                          </GridContainer>

                          <GridContainer direction="column" alignItems="center">
                            <GridItem xs={12} sm={8} md={6}>
                              <div className={classes.editUserFormContainer}>
                                <Button
                                  data-cy="createUser"
                                  id="user-add-button-save"
                                  type="submit"
                                  color="primary"
                                  block
                                >
                                  {t('user.create.submit')}
                                </Button>
                                <Button
                                  id="user-add-button-cancel"
                                  simple
                                  color="danger"
                                  block
                                  onClick={this.handleCancelBtn}
                                >
                                  {t('common.cancel')}
                                </Button>
                              </div>
                            </GridItem>
                          </GridContainer>
                        </CardBody>
                      </Card>
                    </form>
                  </GridItem>
                )}
              />
            </GridContainer>
          );
        }}
      </AuthContext.Consumer>
    );
  }
}

/**
 * UserCreate PropTypes
 * @param classes - prop styles received from withStyles
 * @param errors - prop errors list received from parents
 * @param t - prop from HOC with string translations
 * @callback userCreate - callback called when validations are success
 */

UserCreate.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
  errors: PropTypes.instanceOf(Array).isRequired,
  userCreate: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  agencyId: PropTypes.string,
  fromAgency: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
};

UserCreate.defaultProps = {
  agencyId: '',
};

// to fix: The withStyles HOC set contextTypes to a children component
// and it have problem with contextType assigned to PermissionList component
// This is a small hack, with intermediary Component to resolved it temporally
const UserCreateFormWrapper = props => <UserCreate {...props} />;

export default withTranslation()(
  withStyles(validationFormsStyle)(UserCreateFormWrapper),
);
